export default __webpack_public_path__ + "static/media/LAS0130.34I-30460_-17560_0.5614a11a.jpg";